export default __webpack_public_path__ + "static/media/uv11_en_rudl_a2.a06fa703.mp3";